
import Vue from "vue";
import axios from "axios";
import { UI_ENDPOINT } from "../constants/EndPoints";
import AuthBasic from "../data/authBasic";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";

export default Vue.extend({
  name: "searchHelp",
  mixins: [AppPropsMixin],
  data() {
    return {
      loadingSearchHelpText: false as boolean
    };
  },
  created() {
    //@ts-ignore
    if (this.appProps.searchHelpHTML.length < 1) {
      this.loadingSearchHelpText = true;
      let url = UI_ENDPOINT.GET_SEARCH_HELP_TEXT;

      let that: any = this;
      axios
        .get(url, { auth: AuthBasic })
        .then(response => {
          that.appProps.searchHelpHTML = response.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loadingSearchHelpText = false;
        });
    }
  },
  mounted() {
    document.body.addEventListener("keyup", e => {
      // close dialog on Esacpe or Enter keys
      if (e.key === "Escape" || e.key === "Enter") {
        this.close();
      }
    });
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
});
